import { Controller } from 'stimulus'
import { addEventListener } from 'utils'

const COUNTRY_SWITCHER_ENABLED = Number(window.env.COUNTRY_SWITCHER_ENABLED)
export default class extends Controller {
  static values = {
    activeClass: String,
    drawerSelector: String
  }

  connect () {
    this.drawer = document.querySelector(this.drawerSelectorValue)
    this.removeShowListener = addEventListener(this.drawer, 'show.bs.offcanvas', this.activate.bind(this))
    this.removeHideListener = addEventListener(this.drawer, 'hide.bs.offcanvas', this.deactivate.bind(this))
  }

  disconnect () {
    this.removeShowListener()
    this.removeHideListener()
  }

  activate () {
    if (COUNTRY_SWITCHER_ENABLED) {
      const countrySwitcher = document.getElementById('country-switcher')
      if (countrySwitcher) {
        countrySwitcher.classList.add('d-none')
      }
    }
    this.element.classList.add(this.activeClassValue)
  }

  deactivate () {
    if (COUNTRY_SWITCHER_ENABLED) {
      const countrySwitcher = document.getElementById('country-switcher')
      if (countrySwitcher) {
        countrySwitcher.classList.remove('d-none')
      }
    }
    this.element.classList.remove(this.activeClassValue)
  }
}
